import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

export default defineModule({
    name: 'ssl',
    routes: [
        {
            path: '/ssl',
            meta: {
                layout: 'app',
                permissions: [AppPermissions.ManageSslCertificates],
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
            children: [
                {
                    path: '',
                    name: 'ssl',
                    component: () => import('#modules/ssl/pages/index.vue'),
                },
                {
                    path: ':ssl',
                    name: 'single ssl',
                    component: () => import('#modules/ssl/pages/show.vue'),
                },
                {
                    path: ':ssl/activity-log',
                    name: 'ssl activity log',
                    component: () => import('#modules/ssl/pages/activity-log.vue'),
                },
            ],
        },
    ],
});
